import { FC, ReactNode } from 'react';
import { ProInputNumber } from '../antd';
import SearchFormItem from './subpage/searchFormItem';
import SearchFormDisabled from './subpage/disabled';
import { getInputPlaceholder } from '../utils/ruleUtils';
import {
  BaseSearchFormItemProps,
  SearchFormItemEnum,
} from './interface/baseInterface';
import { NewInputNumberProps } from '../antd/InputNumber/inputNumber';

export interface SearchFormInputNumberProps extends BaseSearchFormItemProps {
  /** 表单头部标题 */
  topTitle?: ReactNode;
  /** 头部标题类名 */
  topTitleClassName?: string;
  /** inputNumber Props */
  inputNumberProps?: NewInputNumberProps & React.RefAttributes<HTMLElement>;
}
/** 数字输入框 */
export const SearchFormInputNumber: FC<SearchFormInputNumberProps> = props => {
  const {
    inputNumberProps,
    render,
    isDetail,
    form,
    disabledRender,
    isTable,
    testId,
    name,
    company,
    companyWidth,
    label,
    rules,
    copy,
    // topTitle,
    // topTitleClassName,
    ...resProps
  } = props;
  return (
    <SearchFormItem
      {...resProps}
      disabled={isDetail || inputNumberProps?.disabled}
      name={name}
      label={label}
      rules={rules}
      test-id={`${testId}-${name}`}
    >
      {isDetail || (inputNumberProps && inputNumberProps.disabled) ? (
        <SearchFormDisabled
          form={form}
          name={name}
          render={render || disabledRender}
          company={company}
          isTable={isTable}
          copy={copy}
        />
      ) : (
        <ProInputNumber
          style={{ width: '100%' }}
          company={company}
          companyWidth={companyWidth}
          {...inputNumberProps}
          placeholder={getInputPlaceholder(label, inputNumberProps, rules)}
        />
        // <div>
        //   {!!topTitle && <div className={topTitleClassName}>{topTitle}</div>}
        //   <ProInputNumber
        //     style={{ width: '100%' }}
        //     company={company}
        //     companyWidth={companyWidth}
        //     {...inputNumberProps}
        //     placeholder={getInputPlaceholder(label, inputNumberProps, rules)}
        //   />
        // </div>
      )}
    </SearchFormItem>
  );
};

SearchFormInputNumber.displayName = SearchFormItemEnum.SearchFormInputNumber;

export default SearchFormInputNumber;
